import React from "react";
import "./Drops.css";
import { cleanName } from "../utils/parser";

export default function Drops({ drops }: { drops: Record<string, number> }) {
  const entries = Object.entries(drops).filter(([, count]) => count > 0);
  if (entries.length <= 0) return null;
  return (
    <div className="drops">
      {entries.map(([key, count]) => (
        <div key={key}>
          <p>{`x${count}`}</p>
          <p>{cleanName(key)}</p>
        </div>
      ))}
    </div>
  );
}
